import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=3a70a798"
import script from "./MultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSelect.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports